// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"d6ce6297","667":"1ac11395","977":"18a79f08"}[chunkId] + ".chunk.js";
};